import { render, staticRenderFns } from "./dailyJournalDiscounts.vue?vue&type=template&id=2822cb37&"
import script from "./dailyJournalDiscounts.vue?vue&type=script&lang=js&"
export * from "./dailyJournalDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports